import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Redirection } from '@tytapp/common';
import { environment } from '@tytapp/environments/environment';

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent {

    constructor(
        private readonly route: ActivatedRoute,
        private redirection: Redirection
    ) {
        this.redirect(route.snapshot.data.id);
    }

    redirect(pageId: string) {
        if (!pageId) return;

        switch (pageId) {
            case 'terms':
                this.redirection.go(`${environment.urls.app}/terms`);
                break;
            case 'privacy':
                this.redirection.go(`${environment.urls.app}/privacy`);
                break;
            case 'core-values':
                this.redirection.go(`${environment.urls.app}/values`);
                break;
        }
    }

}
